import React from 'react'
import { useTranslation } from 'react-i18next'
import Flex from 'typescript-styled-flex'
import styled, { theme } from '../../../theme'
import Expander from '../Expander'
import Text, { HeaderText } from '../Text'
import { Container } from '@material-ui/core'
import { toggleWithLoadUpdateReservationModal } from '../../../actions/bookingCalendar/reservationModal/toggleReservationModal'
import { useDispatch } from 'react-redux'
import { isBefore } from 'date-fns'
import NestedNotification from '../NestedNotification'

const Link = styled.span`
  cursor: pointer;
  color: blue;
`

export default function(notification, markRead, size = 1) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const read = notification.readAt && isBefore(notification.readAt, new Date())

  const openReservation = res => () => {
    dispatch(toggleWithLoadUpdateReservationModal(String(res), true))
  }

  const conflicts = (
    <div
      style={{
        color: read ? 'unset' : theme.colors.palette.tangerine,
        fontSize: `${16 * size}px`,
        fontWeight: 'bold',
        whiteSpace: 'nowrap',
      }}
    >{`${t('BBO_930_conflicts')}: ${
      notification.details.conflictedCounter
    }`}</div>
  )

  return notification.details.conflictedCounter ? (
    <>
      <Expander
        size={size}
        id={notification.id}
        label={
          <>
            {`${t('BBO_930_imports')}: ${notification.details.counter} / `}
            &nbsp;
            {conflicts}
          </>
        }
      >
        <Flex
          column={true}
          justifyCenter={true}
          alignCenter={true}
          style={{
            background: theme.colors.palette.pinkishGrey,
            padding: `${15 * size}px`,
            paddingBottom: `${7 * size}px`,
          }}
        >
          {notification.details.notifications.map((not, index) =>
            NestedNotification(
              not,
              index + 1,
              notification.createdAt,
              'Airbnb',
              size,
            ),
          )}
        </Flex>
      </Expander>
    </>
  ) : (
    <>
      <Expander size={size} id={notification.id}>
        <Text size={size}>
          <HeaderText size={size}>
            <Flex row={true} justifyBetween={true} alignStart={true}>
              {t('OUT_28_airbnb_import')} {notification.details.counter}
            </Flex>
          </HeaderText>
          <Container style={{ padding: '0' }}>
            {notification.details.reservations.map(r => (
              <div>
                {t('title_activity_reservation')}{' '}
                <Link
                  onClick={openReservation(r)}
                  className="blue bbn__box__number"
                >
                  #{r}
                </Link>
              </div>
            ))}
          </Container>
        </Text>
      </Expander>
    </>
  )
}
